import React, { PropTypes } from 'react';

const DraftNotebook = (props)=> {
    return (
    <div className="box-drafts__notebook">
        <p><strong>{props.number}</strong>{props.name}</p>
    </div>
    )
};

DraftNotebook.propTypes = {
    number: PropTypes.number.isRequired,
    name: PropTypes.string
};

DraftNotebook.defaultProps = {
    name: ''
};

export default DraftNotebook;


// WEBPACK FOOTER //
// ./src/_app/drafts/components/Draft/DraftNotebook.jsx